// import { v4 as uuidv4 } from 'uuid'
// import store from '@/store/index'
import moment from 'moment'
const OSS = require('ali-oss')
const ossConfig = {
  // region以杭州为例（oss-cn-hangzhou），其他region按实际情况填写。
  region: 'cn-shanghai',
  // 阿里云主账号AccessKey拥有所有API的访问权限，风险很高。强烈建议您创建并使用RAM账号进行API访问或日常运维，请登录RAM控制台创建RAM账号。
  accessKeyId: 'LTAI5tKkLVm3VPVv22ji8Kn3',
  accessKeySecret: 'CACsOUKePzQ3SiBHzoevEKYhQBf0eu',
  bucket: 'awsacloud',
  endpoint: 'https://oss-cn-shanghai.aliyuncs.com'
}

const client = new OSS(ossConfig)

let tempCheckpoint
// 定义上传方法。
async function multipartUpload (tmpFile, callback) {
  try {
    // object-key可以自定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至当前Bucket或Bucket下的指定目录。
    const slit = `AY220052Z`
    const time = moment().format('YYYYMMDD')
    const fileName = 'uavFiles/' + slit + '/' + time + '/' + tmpFile.name
    // console.log('fileName', fileName)
    const result = await client.multipartUpload(fileName, tmpFile, {
      progress: callback,
      meta: { year: 2020, people: 'test' },
      mime: '.3gp,.mp4,.mpe,.mpg,.mpeg,.mov,.gif,.avi,.dat,.ogg,.mvb,.flv,.m2t'
    })
    return result
  } catch (e) {
    console.log(e)
  }
}

// 暂停分片上传。
client.cancel()

export { multipartUpload, tempCheckpoint }
